// extracted by mini-css-extract-plugin
export default {"Wrapper":"DialogSubmit_Wrapper__5rNzA","SubmitBtn":"DialogSubmit_SubmitBtn__iZ3co","disable":"DialogSubmit_disable__u7BEa","Error":"DialogSubmit_Error__knoVw"};